const clientPurchaseFullcont  = require('./clientPurchase-fullcont')
const clientPurchaseMT        = require('./clientPurchase-fullcont-multitable')
const clientPurchaseMenu      = require('./clientPurchase-menu')

export function start(detail) {  //console.log('goku-dt 5>', detail)

      obj[detail.elem].start(detail)

}/**/

const obj = {

      fullcont:   { start: (detail) =>    { clientPurchaseFullcont.start(detail) } },
      multitable: { start: (detail) =>    { clientPurchaseMT.start(detail) } },
      menu:       { start: (detail) =>    { clientPurchaseMenu.start(detail) } },
}